export class Filter {
    constructor(name, _values, op) {
        this.name = name;
        this._values = _values;
        this.op = op;
    }
    get values() {
        return [...this._values];
    }
}
